var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  useScrollRestoration: () => useScrollRestoration
});
module.exports = __toCommonJS(src_exports);
var import_react = require("react");

// src/storage.ts
var getStorage = () => sessionStorage;
var saveScrollPos = (asPath) => {
  try {
    getStorage().setItem(`scrollPos:${asPath}`, JSON.stringify({ x: window.scrollX, y: window.scrollY }));
  } catch (error) {
  }
};
var restoreScrollPos = (asPath) => {
  try {
    const json = getStorage().getItem(`scrollPos:${asPath}`);
    const scrollPos = json ? JSON.parse(json) : void 0;
    if (scrollPos && scrollPos.y) {
      window.scrollTo(scrollPos.x, scrollPos.y);
    }
  } catch (e) {
  }
};
var deleteScrollPos = (asPath) => {
  try {
    getStorage().removeItem(`scrollPos:${asPath}`);
  } catch (error) {
  }
};

// src/index.ts
function useScrollRestoration(router, { enabled = true } = {}) {
  const shouldRestoreRef = (0, import_react.useRef)(false);
  (0, import_react.useEffect)(() => {
    if (!enabled)
      return;
    if (!("scrollRestoration" in window.history))
      return;
    window.history.scrollRestoration = "manual";
    const onBeforeUnload = (event) => {
      saveScrollPos(router.asPath);
      delete event["returnValue"];
    };
    const onRouteChangeStart = () => {
      saveScrollPos(router.asPath);
    };
    const onRouteChangeComplete = (url) => {
      if (shouldRestoreRef.current) {
        shouldRestoreRef.current = false;
        restoreScrollPos(url);
        deleteScrollPos(url);
      }
    };
    window.addEventListener("beforeunload", onBeforeUnload);
    router.events.on("routeChangeStart", onRouteChangeStart);
    router.events.on("routeChangeComplete", onRouteChangeComplete);
    router.beforePopState(() => {
      shouldRestoreRef.current = true;
      return true;
    });
    return () => {
      window.removeEventListener("beforeunload", onBeforeUnload);
      router.events.off("routeChangeStart", onRouteChangeStart);
      router.events.off("routeChangeComplete", onRouteChangeComplete);
      router.beforePopState(() => true);
    };
  }, [router, enabled]);
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  useScrollRestoration
});
//# sourceMappingURL=index.cjs.map